import Accordion from "react-bootstrap/Accordion";
import * as styles from "../../../../src/data/qmarketing-fuer-den-mittelstand/elements.module.css";
import starclub from "../../../../src/images/produkte/marke/buderus-starclub.jpg";
import bje from "../../../../src/images/produkte/marke/busch-jaeger-excellence.jpg";
import katimex from "../../../../src/images/produkte/marke/katimex.jpg";
import * as React from 'react';
export default {
  Accordion,
  styles,
  starclub,
  bje,
  katimex,
  React
};